import { render, staticRenderFns } from "./manage-pictogram-statuses-next.vue?vue&type=template&id=5af0504f&scoped=true"
import script from "./manage-pictogram-statuses-next.vue?vue&type=script&lang=js"
export * from "./manage-pictogram-statuses-next.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af0504f",
  null
  
)

export default component.exports